import { GameStateId } from '../game/game.state';

export interface NewMemberState { [key: GameStateId]: IActiveTab };

export const INIT_NEW_MEMBER_STATE: NewMemberState = {};

export type IActiveTab = 'counter' | 'info' | 'requests';
